import { FC, useEffect, useState } from 'react';
import { FieldRow, FieldLabel } from 'src/generic/component';
import { validate as roomValidate, IRoom } from 'src/types/org/common/roomSchema';
import { IFieldErrors, ValidationError, ErrorManager, ERRORS_EMPTY } from 'src/types/validation';
import { IFormProps } from 'src/generic/type/form';
import { Button, PrimaryButton } from '@cb/apricot-react';
import { Input, IntegerInput } from 'src/generic/component/form';
import { Draft } from 'src/types/common';

export const RoomForm: FC<IFormProps<IRoom>> = ({ item, onComplete, onCancel }) => {
  const [validating, setValidating] = useState(false);
  const [draft, setDraft] = useState<Draft<IRoom>>(item || {});

  useEffect(() => {
    setDraft(item || {});
  }, [item]);

  let errors: IFieldErrors = ERRORS_EMPTY;
  let validated: IRoom | undefined = undefined;
  try {
    validated = roomValidate(draft);
  } catch (error: any) {
    if (error instanceof ValidationError) {
      errors = error.fieldErrors;
    }
  }

  const { getError, hasError } = ErrorManager(validating ? errors : ERRORS_EMPTY);

  // Run submit logic handler
  const onSubmit = (e: any) => {
    e.preventDefault();
    setValidating(true);
    if (validated)
      onComplete(validated);
  };

  const onClose = () => {
    onCancel();
  };

  const changed = (update: Draft<IRoom>) => {
    setDraft({ ...draft, ...update });
  };

  return (<div>
    <FieldRow>
      <FieldLabel variant="body1">Room Description</FieldLabel>
      <Input validation={hasError('roomType') ? 'error' : undefined} validationMsg={getError('roomType')}
        onChange={(e) => {
          changed({ roomType: e.target.value });
        }}
        value={draft.roomType || ''}
      />
    </FieldRow>
    <FieldRow>
      <FieldLabel variant="body1">Maximum Capacity</FieldLabel>
      <IntegerInput name='maximumCapacity' value={draft.maximumCapacity} onChange={(value) => changed({ maximumCapacity: value })} error={getError('maximumCapacity')} />
    </FieldRow>
    <PrimaryButton style={{ marginRight: '10px' }} onClick={onSubmit}>{item ? 'Update' : 'Add'}</PrimaryButton>
    <Button onClick={onClose}>Cancel</Button>
  </div>);
};